<div class="filter-dialog">
  <div class="header">
    <h1>ФИЛЬТР</h1>
    <button mat-icon-button class="close-button" (click)="onNoClick()">
      <mat-icon>close</mat-icon>
    </button>
  </div>
  <form class="form" [formGroup]="form">
    <pas-multi-select2 label="Архив"
                       [options]="archiveStatuses"
                       [formControlName]="'archive'">
      <ng-template #optionTemplate let-option>
        {{ option.name }}
      </ng-template>
      <ng-template #selectedTemplate let-selected>
        {{ selected.name }}
      </ng-template>
    </pas-multi-select2>

    <pas-multi-select2 label="Критерий"
                       [options]="dataCriterions"
                       [formControlName]="'criterion'"
                       (input)="onInputIndexChange($event)"
    >
      <ng-template #optionTemplate let-option>
        {{ option.name }} ({{ option.shortName }})
      </ng-template>

      <ng-template #selectedTemplate let-selected>
        {{ selected.name }}
      </ng-template>
    </pas-multi-select2>

    <pas-multi-select2 label="Тип оценки"
                       [options]="periods"
                       [formControlName]="'period'">
      <ng-template #optionTemplate let-option>
        {{ option.name }}
      </ng-template>

      <ng-template #selectedTemplate let-selected>
        {{ selected.name }}
      </ng-template>
    </pas-multi-select2>
  </form>
  <div mat-dialog-actions>
    <button [ngClass]="['btn', form.status==='VALID' ? 'btn-blue': 'btn-gray']"
            [ngStyle]="{color:form.status==='VALID' ? '#fff' : '#777'}"
            mat-button cdkFocusInitial [disabled]="form.status!=='VALID'" (click)="onApply()">Применить
    </button>
    <button class="btn btn-secondary" mat-button (click)="onReset()">Сбросить</button>
  </div>
</div>
